module.exports = __webpack_public_path__ + "static/media/Tom Rigsby Headshot.e1d30aa9.jpeg";